/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 *  Type of billing 
 */
export var BillingType = /*#__PURE__*/function (BillingType) {
  BillingType["ONE_TIME"] = "ONE_TIME";
  BillingType["RECURRING"] = "RECURRING";
  return BillingType;
}({});

/**
 * Represents the discount type supported by Coupons
 */
export var CouponDiscountType = /*#__PURE__*/function (CouponDiscountType) {
  CouponDiscountType["FIXED"] = "FIXED";
  CouponDiscountType["FREE_TRIAL"] = "FREE_TRIAL";
  CouponDiscountType["PERCENT"] = "PERCENT";
  return CouponDiscountType;
}({});

/**
 * Represents different discount duration types supported by Coupons
 */
export var CouponDurationType = /*#__PURE__*/function (CouponDurationType) {
  CouponDurationType["FOREVER"] = "FOREVER";
  CouponDurationType["SINGLE_USE"] = "SINGLE_USE";
  CouponDurationType["TEMPORAL"] = "TEMPORAL";
  return CouponDurationType;
}({});

/**
 * Digital line item status enum
 */
export var DigitalOrderLineStatus = /*#__PURE__*/function (DigitalOrderLineStatus) {
  DigitalOrderLineStatus["active"] = "active";
  DigitalOrderLineStatus["cancelled"] = "cancelled";
  DigitalOrderLineStatus["expired"] = "expired";
  DigitalOrderLineStatus["paused"] = "paused";
  DigitalOrderLineStatus["pendingCancel"] = "pendingCancel";
  DigitalOrderLineStatus["pendingPause"] = "pendingPause";
  return DigitalOrderLineStatus;
}({});

/**
 *  The subscription status that indicates access to digital product 
 */
export var MyLatestSubscriptionStatus = /*#__PURE__*/function (MyLatestSubscriptionStatus) {
  MyLatestSubscriptionStatus["ACTIVE"] = "ACTIVE";
  MyLatestSubscriptionStatus["ACTIVE_END_OF_BILLING_CYCLE"] = "ACTIVE_END_OF_BILLING_CYCLE";
  MyLatestSubscriptionStatus["CANCELLED"] = "CANCELLED";
  MyLatestSubscriptionStatus["PAUSED_NO_ACCESS"] = "PAUSED_NO_ACCESS";
  return MyLatestSubscriptionStatus;
}({});

/**
 *  Credit card brand 
 */
export var PaymentCardType = /*#__PURE__*/function (PaymentCardType) {
  PaymentCardType["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
  PaymentCardType["DANKORT"] = "DANKORT";
  PaymentCardType["DINERS_CLUB"] = "DINERS_CLUB";
  PaymentCardType["DISCOVER"] = "DISCOVER";
  PaymentCardType["ELO"] = "ELO";
  PaymentCardType["FORBRUGSFORENINGEN"] = "FORBRUGSFORENINGEN";
  PaymentCardType["HIPERCARD"] = "HIPERCARD";
  PaymentCardType["JCB"] = "JCB";
  PaymentCardType["LASER"] = "LASER";
  PaymentCardType["MAESTRO"] = "MAESTRO";
  PaymentCardType["MASTERCARD"] = "MASTERCARD";
  PaymentCardType["TARJETA_NARANJA"] = "TARJETA_NARANJA";
  PaymentCardType["TEST_CARD"] = "TEST_CARD";
  PaymentCardType["UNDEFINED"] = "UNDEFINED";
  PaymentCardType["UNION_PAY"] = "UNION_PAY";
  PaymentCardType["UNKNOWN"] = "UNKNOWN";
  PaymentCardType["VISA"] = "VISA";
  return PaymentCardType;
}({});

/**
 *  Payment instrument used for the payment/refund 
 */
export var PaymentMethodType = /*#__PURE__*/function (PaymentMethodType) {
  PaymentMethodType["AMAZON"] = "AMAZON";
  PaymentMethodType["AMAZON_BILLING_AGREEMENT"] = "AMAZON_BILLING_AGREEMENT";
  PaymentMethodType["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethodType["BACS"] = "BACS";
  PaymentMethodType["BANK_ACCOUNT_INFO"] = "BANK_ACCOUNT_INFO";
  PaymentMethodType["BOLETO"] = "BOLETO";
  PaymentMethodType["BRAINTREE_APPLE_PAY"] = "BRAINTREE_APPLE_PAY";
  PaymentMethodType["BRAINTREE_V_ZERO"] = "BRAINTREE_V_ZERO";
  PaymentMethodType["CASH_APP"] = "CASH_APP";
  PaymentMethodType["CHECK"] = "CHECK";
  PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
  PaymentMethodType["EFT"] = "EFT";
  PaymentMethodType["GATEWAY_TOKEN"] = "GATEWAY_TOKEN";
  PaymentMethodType["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentMethodType["IBAN_BANK_ACCOUNT"] = "IBAN_BANK_ACCOUNT";
  PaymentMethodType["MONEY_ORDER"] = "MONEY_ORDER";
  PaymentMethodType["OTHER"] = "OTHER";
  PaymentMethodType["PAYPAL"] = "PAYPAL";
  PaymentMethodType["PAYPAL_BILLING_AGREEMENT"] = "PAYPAL_BILLING_AGREEMENT";
  PaymentMethodType["ROKU"] = "ROKU";
  PaymentMethodType["SEPADIRECTDEBIT"] = "SEPADIRECTDEBIT";
  PaymentMethodType["UNDEFINED"] = "UNDEFINED";
  PaymentMethodType["VENMO"] = "VENMO";
  PaymentMethodType["WIRE_TRANSFER"] = "WIRE_TRANSFER";
  return PaymentMethodType;
}({});

/**
 *  State of the plan. 
 */
export var PlanState = /*#__PURE__*/function (PlanState) {
  PlanState["ACTIVE"] = "ACTIVE";
  PlanState["INACTIVE"] = "INACTIVE";
  return PlanState;
}({});

/**
 *  The product type that maps to the product catalog's family ID 
 */
export var ProductFamilyType = /*#__PURE__*/function (ProductFamilyType) {
  ProductFamilyType["CHEGG_MATH"] = "CHEGG_MATH";
  ProductFamilyType["CHEGG_STUDY"] = "CHEGG_STUDY";
  ProductFamilyType["CHEGG_STUDY_PACK"] = "CHEGG_STUDY_PACK";
  ProductFamilyType["CHEGG_WRITING"] = "CHEGG_WRITING";
  return ProductFamilyType;
}({});

/**
 *  The subscriber state of the latest subscription for the product 
 */
export var SubscriberState = /*#__PURE__*/function (SubscriberState) {
  SubscriberState["NEW_SUBSCRIBER"] = "NEW_SUBSCRIBER";
  SubscriberState["RETURNING_SUBSCRIBER"] = "RETURNING_SUBSCRIBER";
  return SubscriberState;
}({});

/**
 *  State for a subscription 
 */
export var SubscriptionState = /*#__PURE__*/function (SubscriptionState) {
  SubscriptionState["ACTIVE"] = "ACTIVE";
  SubscriptionState["CANCELLED"] = "CANCELLED";
  SubscriptionState["EXPIRED"] = "EXPIRED";
  SubscriptionState["PAUSED"] = "PAUSED";
  return SubscriptionState;
}({});

/**
 * Actions users can take to get new subscriptions, or modify existing ones
 */
export var UserSubscriptionAction = /*#__PURE__*/function (UserSubscriptionAction) {
  UserSubscriptionAction["DOWNGRADE"] = "DOWNGRADE";
  UserSubscriptionAction["JOIN"] = "JOIN";
  UserSubscriptionAction["RESUBSCRIBE"] = "RESUBSCRIBE";
  UserSubscriptionAction["RESUME"] = "RESUME";
  UserSubscriptionAction["REVOKE_PENDING_CANCEL"] = "REVOKE_PENDING_CANCEL";
  UserSubscriptionAction["REVOKE_PENDING_PAUSE"] = "REVOKE_PENDING_PAUSE";
  UserSubscriptionAction["UPGRADE"] = "UPGRADE";
  return UserSubscriptionAction;
}({});

/**
 *  Vendors where our subscriptions will be sourced from
 */
export var VendorType = /*#__PURE__*/function (VendorType) {
  VendorType["CHEGG"] = "CHEGG";
  VendorType["RECURLY"] = "RECURLY";
  return VendorType;
}({});

/**
 * User's billing address associated with this purchase
 */

/**
 *  Input type for the preview purchase 
 */

/**
 * Parameters for searching and filtering a product offering
 */

//==============================================================
// END Enums and Input Objects
//==============================================================


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/globalTypes.js
// module id = 382
// module chunks = 11